/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// TODO:   This is temporary component created, Please dont use this, as it will be deleted once all environments tested for search integration
import { useEffect, useState, useCallback, useRef } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { Context, getWidgetData, SearchWidgetItem, WidgetRequestData, ComparisonFacetFilter } from '@sitecore-cloudsdk/search/browser';
import { getTestProps } from 'lib/testing/utils';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { useSearchInitialization } from 'lib/context/SearchInitializationContext';
import { tv } from 'tailwind-variants';
import { RichText } from '@sitecore-content-sdk/nextjs';
import { SEARCH_CONSTANTS } from 'helpers/Constants/SiteConfig';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import SearchFacetFilters from 'helpers/Search/SearchFacetFilters';
import SearchFacetFiltersMobile from 'helpers/Search/SearchFacetFiltersMobile';
import SearchSort from 'helpers/Search/SearchSort';
import SearchFacetTags from 'helpers/Search/SearchFacetTags';
import SearchInputBox from 'helpers/Search/SearchInputBox';
import SearchPagination from 'helpers/Search/SearchPagination';
import useDictionary from 'lib/hooks/useDictionary';
import { sendGTMEvent } from '@next/third-parties/google';
import { mapResultsToTrackEntities, trackSearchFacetClick, trackSearchItemClick, trackSearchNavigationClick, trackSearchWidgetView } from 'lib/search/analytics';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const SearchResult = (props)=>{
    const isEditing = useIsEditing();
    const id = props?.params?.RenderingIdentifier;
    const router = useRouter();
    const searchParams = useSearchParams();
    const searchtermFromUrl = searchParams?.get('searchterm') ?? '';
    const { getDictionaryValue } = useDictionary();
    const { isSearchInitialized } = useSearchInitialization();
    const [searchResult, setSearchResult] = useState([]);
    const [originalFacets, setOriginalFacets] = useState([]);
    const [facets, setFacets] = useState([]);
    const [selectedFacets, setSelectedFacets] = useState([]);
    const [sortOptions, setSortOptions] = useState([]);
    const [selectedSort, setSelectedSort] = useState('most_relevant');
    const [searchTerm, setSearchTerm] = useState(()=>searchtermFromUrl || '');
    const [tempSearchTerm, setTempSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [noResultSuggestion, setNoResultSuggestion] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const itemsPerPage = props?.fields?.resultsPerPage?.value || 8;
    const resultsSectionRef = useRef(null);
    // API Payload State Management
    const [apiPayload, setApiPayload] = useState(()=>{
        const keyphrase = searchtermFromUrl || '';
        return {
            keyphrase,
            facets: [],
            sort: 'most_relevant',
            limit: itemsPerPage,
            offset: 0,
            rfkId: 'rfkid_7'
        };
    });
    const noResultsText = props?.fields?.noSearchResult;
    const { base, filtersSection, mainContentSection, mobileFilterWrapper, mobileFilterSortWrapper, mobileFilterTagsWrapper, totalItemsWrapper, resultCardListWrapper, resultCardList, resultCardItem, resultCardTitle, resultCardDescription, searchAndSortWrapper, searInputWrapper, sortOptionsWrapper, sortMobileOptionsWrapper, noResults, noResultSuggestionLink } = TAILWIND_VARIANTS();
    const sourceId = process.env.NEXT_PUBLIC_SEARCH_GLOBAL_SOURCE_ID ? [
        process.env.NEXT_PUBLIC_SEARCH_GLOBAL_SOURCE_ID
    ] : undefined;
    const getSelectedSortOption = useCallback((selectOption)=>{
        const selectedOption = sortOptions.filter((option)=>option.value === selectOption);
        if (selectedOption.length > 0) {
            return [
                {
                    name: selectedOption[0]?.value
                }
            ];
        }
        return undefined;
    }, [
        sortOptions
    ]);
    const [lastGtmSearchTerm, setLastGtmSearchTerm] = useState(()=>{
        // Initialize from sessionStorage on mount
        if ("object" !== 'undefined') {
            const stored = sessionStorage.getItem('search_result_lastGtmSearchTerm');
            return stored || null;
        }
        return null;
    });
    // Update sessionStorage whenever lastGtmSearchTerm changes
    useEffect(()=>{
        if ("object" !== 'undefined') {
            if (lastGtmSearchTerm) {
                sessionStorage.setItem('search_result_lastGtmSearchTerm', lastGtmSearchTerm);
            } else {
                sessionStorage.removeItem('search_result_lastGtmSearchTerm');
            }
        }
    }, [
        lastGtmSearchTerm
    ]);
    // Update facets with current selected state
    const updateFacetsWithSelectedState = (facets, selectedFacetsItems)=>{
        return facets.map((facet)=>({
                ...facet,
                values: facet.values.map((value)=>({
                        ...value,
                        selected: selectedFacetsItems.find((selectedFacet)=>selectedFacet.name === facet.name)?.value.some((selectedValue)=>selectedValue.id === value.id) || false
                    }))
            }));
    };
    const shallowEqual = (a, b)=>{
        if (a === b) return true;
        if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
        const ak = Object.keys(a), bk = Object.keys(b);
        if (ak.length !== bk.length) return false;
        for (const k of ak){
            if (a[k] !== b[k]) return false;
        }
        return true;
    };
    // API Payload Update Handlers
    const updateApiPayload = (updates)=>{
        setApiPayload((prev)=>{
            const next = {
                ...prev,
                ...updates
            };
            // If nothing *actually* changed, return prev to avoid a rerender/effect run
            return shallowEqual(prev, next) ? prev : next;
        });
    };
    const handleFacetToggle = (facetName, valueId, selected, valueText)=>{
        setSelectedFacets((prev)=>{
            // Find the facet group to get the full facet value object
            const facetGroup = originalFacets.find((f)=>f.name === facetName);
            const fullFacetValue = facetGroup?.values.find((v)=>v.id === valueId);
            if (!fullFacetValue) return prev;
            // Find existing facet in selectedFacets
            const existingFacetIndex = prev.findIndex((facet)=>facet.name === facetName);
            let updatedFacets;
            if (selected) {
                if (existingFacetIndex >= 0) {
                    // Add to existing facet if not already present
                    const existingFacet = prev[existingFacetIndex];
                    const valueExists = existingFacet.value.some((v)=>v.id === valueId);
                    if (!valueExists) {
                        updatedFacets = [
                            ...prev
                        ];
                        updatedFacets[existingFacetIndex] = {
                            ...existingFacet,
                            value: [
                                ...existingFacet.value,
                                fullFacetValue
                            ]
                        };
                    } else {
                        updatedFacets = prev;
                    }
                } else {
                    // Create new facet group
                    updatedFacets = [
                        ...prev,
                        {
                            label: facetGroup?.label || facetName,
                            name: facetName,
                            value: [
                                fullFacetValue
                            ]
                        }
                    ];
                }
            } else {
                if (existingFacetIndex >= 0) {
                    const existingFacet = prev[existingFacetIndex];
                    const updatedValues = existingFacet.value.filter((v)=>v.id !== valueId);
                    if (updatedValues.length === 0) {
                        // Remove entire facet group if no values left
                        updatedFacets = prev.filter((_, index)=>index !== existingFacetIndex);
                    } else {
                        // Update facet with remaining values
                        updatedFacets = [
                            ...prev
                        ];
                        updatedFacets[existingFacetIndex] = {
                            ...existingFacet,
                            value: updatedValues
                        };
                    }
                } else {
                    updatedFacets = prev;
                }
            }
            // Reset to first page when facets change
            setCurrentPage(1);
            // Update API payload with full facet objects and reset offset
            updateApiPayload({
                facets: updatedFacets,
                offset: 0
            });
            return updatedFacets;
        });
        if (selected) {
            sendGTMEvent({
                event: 'filter_click',
                search_type: 'global',
                search_term: tempSearchTerm,
                filter_name: facetName,
                filter_value: valueText,
                results: 'true'
            });
            void trackSearchFacetClick({
                widgetId: 'rfkid_7',
                filters: [
                    {
                        name: facetName,
                        title: facetName,
                        value: valueText,
                        valuePosition: 0,
                        displayName: valueText,
                        facetPosition: 0
                    }
                ],
                request: {
                    keyword: tempSearchTerm || undefined
                }
            });
        }
    };
    const handleClearAll = ()=>{
        setSelectedFacets([]);
        setCurrentPage(1); // Reset to first page when clearing filters
        updateApiPayload({
            facets: [],
            offset: 0
        });
        setSearchResult([]);
        setSearchTerm(apiPayload.keyphrase);
        setTempSearchTerm(apiPayload.keyphrase);
        router.push(`${SEARCH_CONSTANTS.pageUrl}?${new URLSearchParams({
            searchterm: ''
        }).toString()}`);
    };
    const handleSortChange = (optionId, value)=>{
        setSelectedSort(optionId);
        updateApiPayload({
            sort: value
        });
    };
    const handleSearch = (term)=>{
        // Persist before router.push — remount would wipe in-memory values
        if ("object" !== 'undefined') {
            sessionStorage.setItem('search_result_searchInput', term);
            const pendingPosition = sessionStorage.getItem('search_result_pendingSuggestionPosition');
            if (pendingPosition) {
                sessionStorage.setItem('search_result_suggestionPosition', pendingPosition);
                sessionStorage.removeItem('search_result_pendingSuggestionPosition');
            } else {
                sessionStorage.removeItem('search_result_suggestionPosition');
            }
        }
        setIsLoading(true);
        setSearchTerm(term);
        setTempSearchTerm(term);
        setCurrentPage(1); // Reset to first page
        setSelectedFacets([]); // Reset selected facets on new search
        updateApiPayload({
            keyphrase: term,
            offset: 0,
            facets: []
        }); // Reset pagination on new search
        // Update query string with search term
        router.push(`${SEARCH_CONSTANTS.pageUrl}?${new URLSearchParams({
            searchterm: term
        }).toString()}`);
    };
    const handleSuggestionSelect = (_suggestion, index)=>{
        // Parent owns GTM — only stash position for the following onSearch / search_click
        if ("object" === 'undefined') {
            return;
        }
        if (typeof index === 'number' && index >= 0) {
            sessionStorage.setItem('search_result_pendingSuggestionPosition', String(index + 1));
        } else {
            sessionStorage.removeItem('search_result_pendingSuggestionPosition');
        }
    };
    const handleClearSearch = ()=>{
        setSearchTerm('');
        setCurrentPage(1); // Reset to first page
    // Remove searchterm from query string
    // router.push({ pathname: SEARCH_CONSTANTS.pageUrl, query: { searchterm: '' } }, undefined, {
    //   shallow: true,
    // });
    };
    const handlePageChange = (page)=>{
        setCurrentPage(page);
        const newOffset = (page - 1) * itemsPerPage;
        updateApiPayload({
            offset: newOffset
        });
        void trackSearchNavigationClick({
            widgetId: 'rfkid_7',
            itemPosition: page
        });
        // Scroll to results section when page changes
        if (resultsSectionRef.current) {
            resultsSectionRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
            });
        }
    };
    useEffect(()=>{
        const searchTermFromQuery = searchParams?.get('searchterm') ?? '';
        if (searchTermFromQuery.trim() !== '') {
            setIsLoading(true);
            setSearchTerm(searchTermFromQuery);
            setTempSearchTerm(searchTermFromQuery);
            updateApiPayload({
                keyphrase: searchTermFromQuery
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchParams?.toString()
    ]);
    useEffect(()=>{
        if (!isSearchInitialized) {
            return;
        }
        if (apiPayload.keyphrase) {
            const fetchData = async ()=>{
                const context = new Context({
                    locale: {
                        language: 'en',
                        country: 'us'
                    }
                });
                const facetTypeList = apiPayload.facets.length > 0 ? apiPayload.facets.map((facet)=>({
                        name: facet.name,
                        filter: {
                            type: 'or',
                            values: facet.value.map((v)=>new ComparisonFacetFilter('eq', v.text))
                        }
                    })) : undefined;
                // Create a widget request with the entity "product" and widget ID "rfkid_7ss":
                const searchWidget = new SearchWidgetItem('content', 'rfkid_7', {
                    limit: apiPayload.limit,
                    offset: apiPayload.offset,
                    content: {},
                    facet: {
                        all: true,
                        types: facetTypeList
                    },
                    query: {
                        keyphrase: apiPayload.keyphrase || ''
                    },
                    sort: {
                        choices: true,
                        value: getSelectedSortOption(apiPayload.sort)
                    }
                }, sourceId && sourceId.length > 0 ? sourceId : undefined);
                // Call the getWidgetData function with the widget request and the context to retrieve the data:
                const apiData = await getWidgetData(new WidgetRequestData([
                    searchWidget
                ]), context);
                const searchResultData = apiData?.widgets[0]?.content ?? [];
                const facetsData = apiData?.widgets[0]?.facet ?? [];
                const sortData = apiData?.widgets[0]?.sort ?? {};
                setSearchResult(searchResultData);
                setIsLoading(false);
                void trackSearchWidgetView({
                    widgetId: 'rfkid_7',
                    entities: mapResultsToTrackEntities(searchResultData, 'content'),
                    request: {
                        keyword: apiPayload.keyphrase || undefined,
                        numResults: searchResultData.length,
                        totalResults: apiData?.widgets[0]?.total_item ?? searchResultData.length,
                        numRequested: apiPayload.limit,
                        pageNumber: Math.floor(apiPayload.offset / apiPayload.limit) + 1,
                        pageSize: apiPayload.limit
                    }
                });
                if (apiPayload.keyphrase !== lastGtmSearchTerm) {
                    // Get searchType from sessionStorage (set by Hero component), use only once for search_click event
                    let searchTypeForEvent = 'global';
                    // Always send concrete values — undefined keys are omitted from dataLayer
                    let searchInputForEvent = apiPayload.keyphrase || '';
                    let suggestionPositionForEvent = '';
                    let skipSearchClick = false;
                    if ("object" !== 'undefined') {
                        // GlobalSearchInput already pushed search_click — avoid a duplicate on /search
                        const alreadySentTerm = sessionStorage.getItem('search_result_searchClickSent');
                        if (alreadySentTerm === apiPayload.keyphrase) {
                            sessionStorage.removeItem('search_result_searchClickSent');
                            skipSearchClick = true;
                        }
                        const storedSearchType = sessionStorage.getItem('search_result_searchType');
                        if (storedSearchType) {
                            searchTypeForEvent = storedSearchType;
                            // Clear it after use so it's only used once
                            sessionStorage.removeItem('search_result_searchType');
                        }
                        const storedSearchInput = sessionStorage.getItem('search_result_searchInput');
                        if (storedSearchInput !== null) {
                            searchInputForEvent = storedSearchInput;
                            sessionStorage.removeItem('search_result_searchInput');
                        }
                        const storedSuggestionPosition = sessionStorage.getItem('search_result_suggestionPosition');
                        if (storedSuggestionPosition !== null) {
                            const parsedPosition = Number(storedSuggestionPosition);
                            suggestionPositionForEvent = Number.isNaN(parsedPosition) ? storedSuggestionPosition : parsedPosition;
                            sessionStorage.removeItem('search_result_suggestionPosition');
                        }
                    }
                    if (!skipSearchClick) {
                        const searchClickEvent = {
                            event: 'search_click',
                            search_term: apiPayload.keyphrase,
                            search_type: searchTypeForEvent,
                            search_input: searchInputForEvent,
                            suggestion_position: suggestionPositionForEvent,
                            results: searchResultData && searchResultData.length > 0 ? 'true' : 'false'
                        };
                        sendGTMEvent(searchClickEvent);
                    }
                    setLastGtmSearchTerm(apiPayload.keyphrase);
                }
                // Set total items for pagination
                const totalItemsFromApi = apiData?.widgets[0]?.total_item ?? 0;
                setTotalItems(totalItemsFromApi);
                // Transform facets data to match SearchFacetFilters format
                const transformedFacets = facetsData.map((facet)=>({
                        name: facet.name,
                        label: facet.label,
                        values: facet.value.map((value)=>({
                                id: value.id,
                                text: value.text,
                                count: value.count,
                                selected: false
                            }))
                    }));
                // Always update originalFacets with fresh data from API response
                // This ensures facets are always current and reflect the latest search results
                setOriginalFacets(transformedFacets);
                // Always update facets with current selected state
                const updatedFacets = updateFacetsWithSelectedState(transformedFacets, selectedFacets);
                setFacets(updatedFacets);
                // Transform sort data to match SearchSort format
                // The sort data comes from the API response in the format: { choices: SearchSortItemProps[] }
                const sortChoices = sortData?.choices;
                if (sortChoices && sortChoices.length > 0) {
                    // Only set sort options if API provides them
                    const transformedSortOptions = sortChoices.map((choice)=>({
                            id: choice.name,
                            label: choice.label,
                            value: choice.name
                        }));
                    setSortOptions(transformedSortOptions);
                } else {
                    // No sort options from API - set empty array
                    setSortOptions([]);
                }
            };
            fetchData();
        }
    }, [
        apiPayload,
        isSearchInitialized
    ]);
    // Update facets with selected state when selectedFacets changes
    useEffect(()=>{
        if (originalFacets.length > 0) {
            const updatedFacets = updateFacetsWithSelectedState(originalFacets, selectedFacets);
            setFacets(updatedFacets);
        }
    }, [
        selectedFacets,
        originalFacets
    ]);
    useEffect(()=>{
        if (searchTerm && searchTerm !== '' && searchResult.length <= 0) {
            const fetcSuggestionshData = async ()=>{
                const suggestionsContext = new Context({
                    locale: {
                        language: 'en',
                        country: 'us'
                    }
                });
                const suggestWidget = new SearchWidgetItem('content', 'rfkid_6', {
                    limit: 8,
                    offset: 0,
                    content: {},
                    suggestion: [
                        {
                            name: 'did_you_mean_title',
                            max: 3
                        }
                    ],
                    facet: {
                        all: false
                    },
                    query: {
                        keyphrase: searchTerm
                    }
                }, sourceId && sourceId.length > 0 ? sourceId : undefined);
                const suggestionApiData = await getWidgetData(new WidgetRequestData([
                    suggestWidget
                ]), suggestionsContext);
                const suggestionResultData = suggestionApiData?.widgets[0]?.suggestion?.did_you_mean_title ?? [];
                setNoResultSuggestion(suggestionResultData);
            };
            fetcSuggestionshData();
        }
    }, [
        searchTerm,
        searchResult
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            ref: resultsSectionRef,
            "data-component": "authorable/shared/search/searchresult",
            ...editingHydrationProps(isEditing),
            id: id ? id : undefined,
            ...getTestProps(`component-section-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsxs("div", {
                className: base(),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: filtersSection(),
                        children: /*#__PURE__*/ _jsx(SearchFacetFilters, {
                            facets: facets,
                            selectedFacets: selectedFacets,
                            onFacetToggle: handleFacetToggle,
                            onClearAll: handleClearAll,
                            showClearAll: selectedFacets.length > 0
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: mainContentSection(),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: mobileFilterWrapper(),
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: mobileFilterSortWrapper(),
                                        children: [
                                            originalFacets?.length > 0 && /*#__PURE__*/ _jsx(SearchFacetFiltersMobile, {
                                                facets: facets,
                                                selectedFacets: selectedFacets,
                                                onFacetToggle: handleFacetToggle,
                                                onClearAll: handleClearAll,
                                                showClearAll: selectedFacets.length > 0
                                            }),
                                            sortOptions.length > 0 && searchResult.length > 0 && /*#__PURE__*/ _jsx("div", {
                                                className: sortMobileOptionsWrapper(),
                                                children: /*#__PURE__*/ _jsx(SearchSort, {
                                                    options: sortOptions,
                                                    selectedOption: selectedSort,
                                                    onSortChange: handleSortChange,
                                                    label: "Sort by"
                                                })
                                            })
                                        ]
                                    }),
                                    selectedFacets.length > 0 && /*#__PURE__*/ _jsx("div", {
                                        className: mobileFilterTagsWrapper(),
                                        children: /*#__PURE__*/ _jsx(SearchFacetTags, {
                                            selectedFacets: selectedFacets,
                                            onRemoveTag: (facetName, valueId, valueText)=>handleFacetToggle?.(facetName, valueId, false, valueText),
                                            onClearAll: handleClearAll,
                                            showClearAll: selectedFacets.length > 0
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: searchAndSortWrapper(),
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: searInputWrapper(),
                                        children: /*#__PURE__*/ _jsx(SearchInputBox, {
                                            value: searchTerm,
                                            placeholder: getDictionaryValue('SearchInputPlaceholder'),
                                            onSearch: handleSearch,
                                            onSuggestionSelect: handleSuggestionSelect,
                                            onClear: handleClearSearch,
                                            label: "Search"
                                        })
                                    }),
                                    sortOptions.length > 0 && searchResult.length > 0 && /*#__PURE__*/ _jsx("div", {
                                        className: sortOptionsWrapper(),
                                        children: /*#__PURE__*/ _jsx(SearchSort, {
                                            options: sortOptions,
                                            selectedOption: selectedSort,
                                            onSortChange: handleSortChange,
                                            label: getDictionaryValue('SortBy') || 'Sort by'
                                        })
                                    })
                                ]
                            }),
                            totalItems > 0 && /*#__PURE__*/ _jsxs("div", {
                                className: totalItemsWrapper(),
                                children: [
                                    totalItems,
                                    " ",
                                    getDictionaryValue('resultsFor'),
                                    ' "',
                                    tempSearchTerm,
                                    '"'
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: resultCardListWrapper(),
                                children: searchResult && searchResult.length > 0 ? /*#__PURE__*/ _jsx("div", {
                                    className: resultCardList(),
                                    children: searchResult.map((resultItem, index)=>{
                                        return /*#__PURE__*/ _jsxs("div", {
                                            className: resultCardItem(),
                                            children: [
                                                /*#__PURE__*/ _jsx("a", {
                                                    className: resultCardTitle(),
                                                    href: resultItem.url,
                                                    onClick: ()=>{
                                                        void trackSearchItemClick({
                                                            widgetId: 'rfkid_7',
                                                            entity: {
                                                                id: resultItem.id,
                                                                entity: 'content',
                                                                uri: resultItem.url,
                                                                sourceId: resultItem.source_id
                                                            },
                                                            itemPosition: index,
                                                            request: {
                                                                keyword: tempSearchTerm || undefined,
                                                                numResults: searchResult.length,
                                                                totalResults: totalItems
                                                            }
                                                        });
                                                    },
                                                    children: resultItem.name
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: resultCardDescription(),
                                                    children: /*#__PURE__*/ _jsx(RichText, {
                                                        field: {
                                                            value: resultItem.description
                                                        }
                                                    })
                                                })
                                            ]
                                        }, resultItem.id);
                                    })
                                }) : /*#__PURE__*/ _jsx("div", {
                                    className: resultCardList(),
                                    children: !!searchTerm && searchResult.length <= 0 && !isLoading && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(RichTextWrapper, {
                                                className: noResults(),
                                                field: noResultsText,
                                                ...getTestProps(`no-results`)
                                            }),
                                            noResultSuggestion && noResultSuggestion.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            getDictionaryValue('DidYouMean'),
                                                            ' ',
                                                            noResultSuggestion.map((suggestion, index)=>{
                                                                return /*#__PURE__*/ _jsxs("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("a", {
                                                                            href: '/search?searchterm=' + suggestion.text,
                                                                            className: noResultSuggestionLink(),
                                                                            children: suggestion.text
                                                                        }),
                                                                        index < noResultSuggestion.length - 1 && index !== noResultSuggestion.length - 2 && ', ',
                                                                        index === noResultSuggestion.length - 2 && ' or '
                                                                    ]
                                                                }, 'suggestion' + index);
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: getDictionaryValue('CheckIncorrectSpelling')
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        ]
                                    })
                                })
                            }),
                            totalItems > itemsPerPage && /*#__PURE__*/ _jsx(SearchPagination, {
                                currentPage: currentPage,
                                totalPages: Math.ceil(totalItems / itemsPerPage),
                                totalItems: totalItems,
                                itemsPerPage: itemsPerPage,
                                onPageChange: handlePageChange,
                                showPageNumbers: true,
                                maxVisiblePages: 5
                            })
                        ]
                    })
                ]
            })
        })
    });
};
export const Default = withStandardComponentWrapper(SearchResult);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'flex',
            'flex-col md:flex-row',
            'md:min-w-[230px]',
            'md:justify-end',
            'py-padding-loose',
            'gap-spacing-spacing-24'
        ],
        filtersSection: [
            'w-full py-spacing-spacing-8 hidden lg:block lg:w-1/4'
        ],
        mainContentSection: [
            'w-full',
            'flex',
            'flex-1',
            'flex-col',
            'gap-padding-loose'
        ],
        mobileFilterWrapper: [
            'lg:hidden',
            'flex',
            'flex-col',
            'items-center',
            'justify-between',
            'gap-spacing-spacing-8',
            'w-full',
            'relative',
            'z-[10]'
        ],
        mobileFilterSortWrapper: [
            'flex',
            'flex-row',
            'items-center',
            'justify-between',
            'gap-spacing-spacing-8',
            'w-full'
        ],
        mobileFilterTagsWrapper: [
            'py-spacing-spacing-8',
            'w-full',
            'flex',
            'flex-row',
            'gap-spacing-spacing-8',
            'justify-start',
            'items-center'
        ],
        totalItemsWrapper: [
            'w-full',
            'text-color-text-dark',
            'font-typography-font-family-body',
            'text-typography-font-size-body-large',
            'font-bold',
            'leading-typography-line-height-body-large'
        ],
        searchAndSortWrapper: [
            'w-full',
            'pt-padding-micro',
            'flex',
            'flex-row',
            'justify-between',
            'items-center',
            'gap-spacing-spacing-24',
            'relative',
            'z-[9]'
        ],
        searInputWrapper: [
            'w-full',
            'md:min-w-[280px]',
            'md:flex-1',
            'md:max-w-[611px]'
        ],
        sortOptionsWrapper: [
            'w-fit',
            'flex-1',
            'relative',
            'lg:block hidden'
        ],
        sortMobileOptionsWrapper: [
            'w-fit',
            'flex-1',
            'relative',
            'lg:hidden block'
        ],
        searchKeywordWrapper: [
            'relative',
            'lg:grid',
            'col-start-1',
            'col-end-3',
            'hidden'
        ],
        resultCardListWrapper: [
            'w-full',
            'flex',
            'flex-col',
            'md:w-3/4',
            'md:max-w-[611px] lg:max-w-[744px]'
        ],
        resultCardList: [
            'w-full',
            'flex',
            'flex-col',
            'gap-padding-loose'
        ],
        resultCardItem: [
            'w-full',
            'flex',
            'flex-col'
        ],
        resultCardTitle: [
            'font-typography-font-family-body',
            'font-semibold',
            'font-normal',
            'text-color-core-color-4-skyblue-darkTint',
            'text-typography-font-size-body-large',
            'leading-[24px]',
            'hover:underline'
        ],
        resultCardDescription: [
            'text-component-card-on-bg-body',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-normal',
            'leading-typography-line-height-body-medium',
            'line-clamp-2'
        ],
        searchTextInputStyle: [
            'py-spacing-spacing-8',
            'pr-spacing-spacing-8',
            'pl-spacing-spacing-32',
            'bg-color-grayscale-white',
            'border-border-width-width-025',
            'border-color-border-border',
            'rounded-component-tab-border-radius',
            'text-color-text-text',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium'
        ],
        filterButtonText: [
            'text-component-button-primary-outline-text',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-semibold'
        ],
        desktopFilterWrapper: [
            'lg:block',
            'hidden'
        ],
        noResults: [
            'w-full',
            'text-commponent-search-no-results-text'
        ],
        noResultSuggestionLink: [
            'text-color-core-color-4-skyblue-darkTint',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'leading-typography-line-height-body-medium',
            'font-normal',
            'underline',
            'hover:no-underline'
        ],
        sortByWrapper: [
            'flex',
            'gap-2',
            'items-center',
            'col-span-1',
            'col-start-3',
            'col-end-3',
            'xl:col-start-4',
            'xl:col-end-5',
            'md:justify-end',
            'justify-start',
            'w-full'
        ],
        searchIconStyle: [
            'absolute',
            'left-spacing-spacing-10',
            'top-3'
        ],
        filterOverLayWrapper: [
            'fixed',
            'inset-0',
            'z-50',
            'flex',
            'flex-col',
            'bg-color-surface-surface',
            'pt-spacing-spacing-16',
            'lg:hidden'
        ],
        overLayCloseWrapper: [
            'flex',
            'justify-end',
            'bg-color-surface-surface',
            'px-spacing-spacing-16'
        ],
        overLayContentWrapper: [
            'bg-color-surface-surface',
            'overflow-y-auto'
        ],
        mobileSearchWrapper: [
            'lg:hidden',
            'block',
            'z-10'
        ],
        filteredTags: [
            'block',
            'lg:hidden'
        ],
        paginationWrapper: [],
        totalSearchKeywordStyle: [
            'text-color-icon-darkest',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-bold'
        ],
        filterTagWrapper: [
            '!px-0'
        ],
        closeIcon: [
            'text-color-icon-icon'
        ]
    }
});
